import PubBaseLayout from "@pub/BaseLayout";
import { configHeader, configNewsletter, configSite } from "@pub/config";
import MetaData from "@src/app/components/Modules/MetaData";
import AppNewsletter from "@src/app/components/Modules/Newsletter/AppNewsletter";
import SocialMedia from "@src/app/components/Modules/SocialMedia/SocialMedia";
import { ReactElement } from "react";

import styles from "./newslettersignup.module.css";

export default function NewsletterSignupPage(): ReactElement {
  const newsLetterProps = {
    backgroundImage: configNewsletter.image || "",
    newsletterCtaText: configNewsletter.signUpText || "SIGN UP",
    emailPlaceHolder: {
      placeholder: configNewsletter.emailPlaceHolderText || "Email Address",
    },
    newsletterBody: configNewsletter.body || "",
    newsletterTitle: configNewsletter.title || "",
    newsletterLang: configNewsletter.lang || "",
  };
  return (
    <PubBaseLayout ads={false} skipMobileBanner>
      <MetaData title="Newsletter" type="WebPage" path="/newsletter-signup" />
      <div className={styles.newsletterOuterContainer}>
        <AppNewsletter {...newsLetterProps} variant="standalone" />

        {configSite.socialMedia && (
          <SocialMedia
            data={configHeader.socialMedia}
            title={configSite.socialMedia.title}
          />
        )}
      </div>
    </PubBaseLayout>
  );
}
